import { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import { dispatch } from "../../../../state/store";
import { setLocalizationToApp } from "../../../../state/ducks";

import { strCode } from "../../../../consts";
import { localisationTabUtils } from "../utils/localisationTabUtils";
import { useIsLocalisationEditing } from "../hooks/useIsLocalisationEditing";
import { useDebounce } from "../../../../hooks";

import { Input, WrapperContainer } from "../../../../components";
import { LangTitle } from "../styled";

export const NameCell = ({ cell, getEditingLocalization }) => {
  const [name, setName] = useState(cell.row.original?.name);

  useEffect(() => {
    setName(cell.row.original.name);
  }, [cell.row.original?.name]);

  const selectedApp = useSelector((store) => store.apps.selectedApp);
  const localizations = useMemo(() => selectedApp.localizations, [selectedApp]);

  const isTouched = useRef(false);
  const isValid = useMemo(() => {
    return localisationTabUtils.validateName(name);
  }, [name]);

  const { isLocalizationEditing } = useIsLocalisationEditing({
    originalRow: cell.row.original,
    isNameCell: true,
    getEditingLocalization
  });

  useEffect(() => {
    if (cell.row.original?.language && isLocalizationEditing && !isTouched.current) {
      setName(cell.row.original.language);
      isTouched.current = true;
    }
  }, [cell.row.original.language, isLocalizationEditing]);

  const handleUpdatedLocalizations = () => {
    const newLocalizations = [...localizations].map((localization) => {
      if (localization.isNew) {
        return {
          ...localization,
          ...cell.row.original,
          name
        };
      }

      return localization;
    });

    dispatch(setLocalizationToApp(newLocalizations));
  };

  useDebounce(handleUpdatedLocalizations, 100, name);

  return (
    <>
      {!isLocalizationEditing ? (
        <LangTitle>{name}</LangTitle>
      ) : (
        <WrapperContainer width={"100%"} mr={20}>
          <Input
            id={"name"}
            placeholder={strCode.NAME_TITLE}
            value={name}
            setValue={setName}
            hasError={isTouched.current && !isValid}
            onBlur={() => {
              isTouched.current = true;
            }}
          />
        </WrapperContainer>
      )}
    </>
  );
};

NameCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.string.isRequired,
    row: PropTypes.shape({
      original: PropTypes.shape({
        language: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  getEditingLocalization: PropTypes.func.isRequired
};
